import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.resource?.item_count;
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
// Síguenos dropdown
(function() {
  const toggle = document.querySelector('.social-follow-toggle');
  const dropdown = document.querySelector('.social-follow-dropdown');
  if (!toggle || !dropdown) return;

  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    const isOpen = dropdown.classList.contains('is-open');
    dropdown.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('click', function() {
    dropdown.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  });
})();
